var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlerta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.151,
    height: 97.151,
    viewBox: "0 0 97.151 97.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alerta",
    transform: "translate(-905 -340)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9995",
    "data-name": "Caminho 9995",
    d: "M53.376,5a48.576,48.576,0,1,0,48.576,48.576A48.58,48.58,0,0,0,53.376,5Zm0,92.834A44.258,44.258,0,1,1,97.634,53.576,44.318,44.318,0,0,1,53.376,97.834Zm0-34a2.165,2.165,0,0,0,2.159-2.159v-27.2a2.159,2.159,0,0,0-4.318,0V61.78A2.146,2.146,0,0,0,53.376,63.831Zm-.324,8.636c-.108,0-.324.108-.432.108s-.216.108-.324.216-.216.108-.324.324a2.087,2.087,0,0,0,0,3.022c.108.108.216.216.324.216.108.108.216.108.324.216a.649.649,0,0,0,.432.108h.432a2.137,2.137,0,0,0,1.511-3.67A2.572,2.572,0,0,0,53.052,72.466Z",
    transform: "translate(900.2 335)",
    fill: "#f49838"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerta);
export default __webpack_public_path__ + "static/media/alerta.5764c481d22c3b156439db26784fd872.svg";
export { ForwardRef as ReactComponent };